import { render, staticRenderFns } from "./TransferFromDebtor.vue?vue&type=template&id=76006594&scoped=true&"
import script from "./TransferFromDebtor.vue?vue&type=script&lang=js&"
export * from "./TransferFromDebtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76006594",
  null
  
)

export default component.exports